import { Component, HostBinding, Input } from '@angular/core';
import { ETooltipPlacement, TTooltipTheme } from './tooltip.types';
import { NgClass } from '@angular/common';
import { IconComponent } from '../icon/icon.component';

@Component({
    selector: 'fk-tooltip',
    templateUrl: './tooltip.component.html',
    styleUrl: './tooltip.component.scss',
    imports: [NgClass, IconComponent]
})
export class TooltipComponent {
  @Input()
  public content: string = '';

  @Input()
  public width: string = '100%';

  @Input()
  public theme: TTooltipTheme = 'light';

  @Input()
  @HostBinding('style.left.px')
  public positionX: number = 0;

  @Input()
  @HostBinding('style.top.px')
  public positionY: number = 0;

  @Input()
  @HostBinding('style.width.px')
  public containerWidth: number = 0;

  @Input()
  @HostBinding('style.height.px')
  public containerHeight: number = 0;

  @Input()
  public tooltipWidth: string = '100%';

  @Input()
  set placement(placement: ETooltipPlacement | null) {
    this.className = `fk-tooltip--${placement}`;
  }

  public className: string | null = null;
}
